/**
 * --------------------------------------------------------------------------
 * Basic Modules: Parallax.js
 * --------------------------------------------------------------------------
 */

"use strict";

/*
 * Constants
 */

const DEBUG             = true;
const NAME              = 'parallax';
const DATA_KEY          = NAME;
const EVENT_KEY         = `.${DATA_KEY}`;
const LOG_KEY           = `[${NAME}]`;

const Default = {
    mouseResponse: true,
    mouseActiveOutside: false,
    triggerResponse: true,
    triggerExposesEdges: false,
    xparallax: true,
    yparallax: true,
    xorigin: 0.5,
    yorigin: 0.5,
    xtravel: 1,
    ytravel: 1,
    takeoverFactor: 0.65,
    takeoverThresh: 0.002,
    frameDuration: 25
};

const Event = {
    RESIZE              : `resize${EVENT_KEY} orientationchange${EVENT_KEY}`,
    SCROLL              : `scroll${EVENT_KEY}`,
    CLICK               : `click${EVENT_KEY}`,
};

const ClassName = {
};

const Selector = {
    TOGGLE              : `[data-toggle-parallax]`,
};

const DataAttr = {
    ACTIVE              : 'data-active',
    AILMENT_ID          : 'data-ailment-id',
};

class Parallax {

    constructor(element, config) {

        DEBUG && console.log(LOG_KEY, '::constructor() invoked');
        let self = this;

        this.element = element;
        this.$element = $(this.element);
        this.config  = this.getConfig(config);

        this.initOrigin();

        this.settingsLayer = {
            xparallax: this.config.xparallax,
            yparallax: this.config.yparallax,
            xorigin: this.config.xorigin,
            yorigin: this.config.yorigin,
            xtravel: this.config.xtravel,
            ytravel: this.config.ytravel
        };

        this.settingsMouseport = {
            element: this.config.mouseport,
            takeoverFactor: this.config.takeoverFactor,
            takeoverThresh: this.config.takeoverThresh
        };

        if (this.config.mouseport) this.settingsMouseport['element'] = this.config.mouseport;
        this.layersettings = [];
        for (let a = 1, len = arguments.length; a < len; a++) {
            this.layersettings.push($.extend({}, this.settingsLayer, arguments[a]));
        }

        var localmouse = {x: 0.5, y: 0.5};
        var virtualmouse = {x: 0.5, y: 0.5};
        var timer = {
            running: false, frame: this.config.frameDuration, fire: function (x, y) {
                self.positionMouse(mouseport, localmouse, virtualmouse);
                self.moveLayers(layer, virtualmouse.x, virtualmouse.y);
                this.running = setTimeout(function () {
                    if (localmouse.x !== x || localmouse.y !== y || !mouseport.ontarget) {
                        timer.fire(localmouse.x, localmouse.y);
                    } else if (timer.running) {
                        timer.running = false;
                    }
                }, timer.frame);
            }
        };
        var viewport = { element: this.$element };

        var mouseport = $.extend({}, {element: viewport.element}, this.settingsMouseport, {
            xinside: false,
            yinside: false,
            active: false,
            ontarget: false
        });
        var layer = [];

        this.setupPorts(viewport, mouseport);
        for (var i = 0; i < viewport.element.children().length; i++) {
            layer[i] = $.extend({}, this.settingsLayer, this.layersettings[i], {element: viewport.element.children('*:eq(' + i + ')')});
            this.setupLayer(layer, i, mouseport);
            if (this.config.triggerResponse) {
                this.setupLayerContents(layer, i, viewport.element.offset());
            }
        }
        viewport.element.children().css('position', 'absolute');
        this.moveLayers(layer, 0.5, 0.5);

        if (this.config.mouseResponse) {
            viewport.element.mousemove(function (mouse) {
                mouseport.xinside = (mouse.pageX >= mouseport.left && mouse.pageX < mouseport.width + mouseport.left) ? true : false;
                mouseport.yinside = (mouse.pageY >= mouseport.top && mouse.pageY < mouseport.height + mouseport.top) ? true : false;
                if (mouseport.xinside && mouseport.yinside && !mouseport.active) {
                    mouseport.ontarget = false;
                    mouseport.active = true;
                }
                if (mouseport.active) {
                    if (mouseport.xinside) {
                        localmouse.x = (mouse.pageX - mouseport.left) / mouseport.width;
                    } else {
                        localmouse.x = (mouse.pageX < mouseport.left) ? 0 : 1;
                    }
                    if (mouseport.yinside) {
                        localmouse.y = (mouse.pageY - mouseport.top) / mouseport.height;
                    } else {
                        localmouse.y = (mouse.pageY < mouseport.top) ? 0 : 1;
                    }
                }
                if (mouseport.xinside && mouseport.yinside) {
                    if (!timer.running) timer.fire(localmouse.x, localmouse.y);
                } else if (mouseport.active) {
                    mouseport.active = false;
                }
            });
        }
        if (this.config.triggerResponse) {

            viewport.element.on("parallax", function (event, ref) {
                ref = self.stripFiletype(ref);
                self.matrixSearch(layer, ref, function (i, n) {
                    localmouse.x = layer[i].content[n].posxrat * (layer[i].diffxrat + 1) - (0.5 * layer[i].diffxrat);
                    localmouse.y = layer[i].content[n].posyrat * (layer[i].diffyrat + 1) - (0.5 * layer[i].diffyrat);
                    if (!this.config.triggerExposesEdges) {
                        if (localmouse.x < 0) localmouse.x = 0;
                        if (localmouse.x > 1) localmouse.x = 1;
                        if (localmouse.y < 0) localmouse.y = 0;
                        if (localmouse.y > 1) localmouse.y = 1;
                    }
                    mouseport.ontarget = false;
                    if (!timer.running) timer.fire(localmouse.x, localmouse.y);
                });
            });
        }
        $(window).on('resize', function () {
            self.setupPorts(viewport, mouseport);
            for (var i = 0; i < layer.length; i++) {
                self.setupLayer(layer, i, mouseport);
            }
        });

        this.addEventListeners();
    }

    destroy() {
        this.$element.off(EVENT_KEY);
        this.$element.removeData(DATA_KEY);
        this.$element = null;
        this.element = null;
    }

    addEventListeners() {
        //$(window).on(Event.RESIZE, (event) => this.handleResize(event));
    }

    getConfig(config) {
        return {
            ...Default,
            ...config
        };
    }

    matrixSearch(layer, ref, callback) {
        for (var i = 0; i < layer.length; i++) {
            var gotcha = false;
            for (var n = 0; n < layer[i].content.length; n++) {
                if (layer[i].content[n].anchor === ref) {
                    callback(i, n);
                    return [i, n];
                }
            }
        }
        return false;
    }

    stripFiletype(ref) {
        var x = ref.replace('.html', '');
        return x.replace('#', '');
    }

    initOrigin() {
        if (this.config.xorigin === 'left') {
            this.config.xorigin = 0;
        } else if (this.config.xorigin === 'middle' || this.config.xorigin === 'centre' || this.config.xorigin === 'center') {
            this.config.xorigin = 0.5;
        } else if (this.config.xorigin === 'right') {
            this.config.xorigin = 1;
        }
        if (this.config.yorigin === 'top') {
            this.config.yorigin = 0;
        } else if (this.config.yorigin === 'middle' || this.config.yorigin === 'centre' || this.config.yorigin === 'center') {
            this.config.yorigin = 0.5;
        } else if (this.config.yorigin === 'bottom') {
            this.config.yorigin = 1;
        }
    }

    positionMouse(mouseport, localmouse, virtualmouse) {
        var difference = {x: 0, y: 0, sum: 0};
        if (!mouseport.ontarget) {
            difference.x = virtualmouse.x - localmouse.x;
            difference.y = virtualmouse.y - localmouse.y;
            difference.sum = Math.sqrt(difference.x * difference.x + difference.y * difference.y);
            virtualmouse.x = localmouse.x + difference.x * mouseport.takeoverFactor;
            virtualmouse.y = localmouse.y + difference.y * mouseport.takeoverFactor;
            if (difference.sum < mouseport.takeoverThresh && difference.sum > mouseport.takeoverThresh * -1) {
                mouseport.ontarget = true;
            }
        } else {
            virtualmouse.x = localmouse.x;
            virtualmouse.y = localmouse.y;
        }
    }

    setupPorts(viewport, mouseport) {
        var offset = mouseport.element.offset();
        $.extend(viewport, {width: viewport.element.width(), height: viewport.element.height()});
        $.extend(mouseport, {
            width: mouseport.element.width(),
            height: mouseport.element.height(),
            top: offset.top,
            left: offset.left
        });
    }

    parseTravel(travel, origin, dimension) {
        var offset;
        var cssPos;
        if (typeof (travel) === 'string') {
            if (travel.search(/^\d+\s?px$/) !== -1) {
                travel = travel.replace('px', '');
                travel = parseInt(travel, 10);
                offset = origin * (dimension - travel);
                cssPos = origin * 100 + '%';
                return {travel: travel, travelpx: true, offset: offset, cssPos: cssPos};
            } else if (travel.search(/^\d+\s?%$/) !== -1) {
                travel.replace('%', '');
                travel = parseInt(travel, 10) / 100;
            } else {
                travel = 1;
            }
        }
        offset = origin * (1 - travel);
        return {travel: travel, travelpx: false, offset: offset}
    }

    setupLayer(layer, i, mouseport) {
        var xStuff;
        var yStuff;
        var cssObject = {};
        layer[i] = $.extend({}, {width: layer[i].element.width(), height: layer[i].element.height()}, layer[i]);
        xStuff = this.parseTravel(layer[i].xtravel, layer[i].xorigin, layer[i].width);
        yStuff = this.parseTravel(layer[i].ytravel, layer[i].yorigin, layer[i].height);
        $.extend(layer[i], {
            diffxrat: mouseport.width / (layer[i].width - mouseport.width),
            diffyrat: mouseport.height / (layer[i].height - mouseport.height),
            xtravel: xStuff.travel,
            ytravel: yStuff.travel,
            xtravelpx: xStuff.travelpx,
            ytravelpx: yStuff.travelpx,
            xoffset: xStuff.offset,
            yoffset: yStuff.offset
        });
        if (xStuff.travelpx) {
            cssObject.left = xStuff.cssPos;
        }
        if (yStuff.travelpx) {
            cssObject.top = yStuff.cssPos;
        }
        if (xStuff.travelpx || yStuff.travelpx) {
            layer[i].element.css(cssObject);
        }
    }

    setupLayerContents(layer, i, viewportOffset) {
        var contentOffset;
        $.extend(layer[i], {content: []});
        for (var n = 0; n < layer[i].element.children().length; n++) {
            if (!layer[i].content[n]) layer[i].content[n] = {};
            if (!layer[i].content[n].element) layer[i].content[n]['element'] = layer[i].element.children().eq(n);
            if (!layer[i].content[n].anchor && layer[i].content[n].element.children('a').attr('name')) {
                layer[i].content[n]['anchor'] = layer[i].content[n].element.children('a').attr('name');
            }
            if (layer[i].content[n].anchor) {
                contentOffset = layer[i].content[n].element.offset();
                $.extend(layer[i].content[n], {
                    width: layer[i].content[n].element.width(),
                    height: layer[i].content[n].element.height(),
                    x: contentOffset.left - viewportOffset.left,
                    y: contentOffset.top - viewportOffset.top
                });
                $.extend(layer[i].content[n], {
                    posxrat: (layer[i].content[n].x + layer[i].content[n].width / 2) / layer[i].width,
                    posyrat: (layer[i].content[n].y + layer[i].content[n].height / 2) / layer[i].height
                });
            }
        }
    }

    moveLayers(layer, xratio, yratio) {
        var xpos;
        var ypos;
        var cssObject;
        for (var i = 0; i < layer.length; i++) {
            xpos = layer[i].xtravel * xratio + layer[i].xoffset;
            ypos = layer[i].ytravel * yratio + layer[i].yoffset;
            cssObject = {};
            if (layer[i].xparallax) {
                if (layer[i].xtravelpx) {
                    cssObject.marginLeft = xpos * -1 + 'px';
                } else {
                    cssObject.left = xpos * 100 + '%';
                    cssObject.marginLeft = xpos * layer[i].width * -1 + 'px';
                }
            }
            if (layer[i].yparallax) {
                if (layer[i].ytravelpx) {
                    cssObject.marginTop = ypos * -1 + 'px';
                } else {
                    cssObject.top = ypos * 100 + '%';
                    cssObject.marginTop = ypos * layer[i].height * -1 + 'px';
                }
            }
            layer[i].element.css(cssObject);
        }
    }

    // Static

    /**
     * Convenient static method to initiate the module.
     *
     * @param config
     * @param selector
     */
    static bind (config, selector) {
        Parallax.jQueryInterface.call($(selector || Selector.TOGGLE), config);
    }

    /**
     * jQuery Interface
     * @param config
     * @returns {*}
     */
    static jQueryInterface(config) {
        return this.each(function() {
            const $this = $(this);
            let data    = $this.data(DATA_KEY);
            let _config = {
                ...Default,
                ...$this.data(),
                ...typeof config === 'object' && config ? config : {}
            };

            if (!data) {
                data = new Parallax(this, _config);
                $this.data(DATA_KEY, data);
            }

            if (typeof config === 'string') {
                if (typeof data[config] === 'undefined') {
                    throw new TypeError(`No method named "${config}"`);
                }
                data[config]();
            }
        });
    }
}

/**
 * ------------------------------------------------------------------------
 * jQuery
 * ------------------------------------------------------------------------
 */

$.fn[NAME]             = Parallax.jQueryInterface;
$.fn[NAME].Constructor = Parallax;

export default Parallax;
